export const googleFonts = [
  { name: 'Inter', value: 'Inter' },
  { name: 'Roboto', value: 'Roboto' },
  { name: 'Open Sans', value: 'Open Sans' },
  { name: 'Lato', value: 'Lato' },
  { name: 'Montserrat', value: 'Montserrat' },
  { name: 'Oswald', value: 'Oswald' },
  { name: 'Source Sans Pro', value: 'Source Sans Pro' },
  { name: 'Raleway', value: 'Raleway' },
  { name: 'PT Sans', value: 'PT Sans' },
  { name: 'Merriweather', value: 'Merriweather' },
  { name: 'Nunito', value: 'Nunito' },
  { name: 'Poppins', value: 'Poppins' },
  { name: 'Playfair Display', value: 'Playfair Display' },
  { name: 'Ubuntu', value: 'Ubuntu' },
  { name: 'Lora', value: 'Lora' },
  { name: 'Noto Sans', value: 'Noto Sans' },
  { name: 'Slabo 27px', value: 'Slabo 27px' },
  { name: 'Roboto Condensed', value: 'Roboto Condensed' },
  { name: 'Roboto Mono', value: 'Roboto Mono' },
  { name: 'Roboto Slab', value: 'Roboto Slab' },
  { name: 'Arimo', value: 'Arimo' },
  { name: 'Fira Sans', value: 'Fira Sans' },
  { name: 'Work Sans', value: 'Work Sans' },
  { name: 'Quicksand', value: 'Quicksand' },
  { name: 'Dosis', value: 'Dosis' },
  { name: 'Oxygen', value: 'Oxygen' },
  { name: 'Inconsolata', value: 'Inconsolata' },
  { name: 'Cabin', value: 'Cabin' },
  { name: 'Libre Baskerville', value: 'Libre Baskerville' },
  { name: 'Bitter', value: 'Bitter' },
  { name: 'Crimson Text', value: 'Crimson Text' },
  { name: 'Yantramanav', value: 'Yantramanav' },
  { name: 'Varela Round', value: 'Varela Round' },
  { name: 'Anton', value: 'Anton' },
  { name: 'Dancing Script', value: 'Dancing Script' },
  { name: 'Pacifico', value: 'Pacifico' },
  { name: 'Shadows Into Light', value: 'Shadows Into Light' },
  { name: 'Amatic SC', value: 'Amatic SC' },
  { name: 'Josefin Sans', value: 'Josefin Sans' },
  { name: 'Bebas Neue', value: 'Bebas Neue' },
  { name: 'Comfortaa', value: 'Comfortaa' },
  { name: 'Exo 2', value: 'Exo 2' },
  { name: 'Maven Pro', value: 'Maven Pro' },
  { name: 'Signika', value: 'Signika' },
  { name: 'Teko', value: 'Teko' },
  { name: 'Architects Daughter', value: 'Architects Daughter' },
  { name: 'Caveat', value: 'Caveat' },
  { name: 'Indie Flower', value: 'Indie Flower' },
  { name: 'Patrick Hand', value: 'Patrick Hand' },
  { name: 'Permanent Marker', value: 'Permanent Marker' },
];
